import { formatBalance } from '@ui/src';
import { useAppSelector } from '@store';
import { BalanceFrsItemTypes } from './types';

import cn from './balance.module.css';

const BalanceFrsItem = ({
  title,
  children,
  total,
  withHint,
  left,
  right,
}: BalanceFrsItemTypes) => {
  const { baseCurrency } = useAppSelector((state) => state.reportsDictionaries);

  return (
    <div className={cn.balanceFrsItem}>
      <div className={cn.balanceFrsItemTitle}>
        <div className={cn.balanceFrsItemTitleDesription}>
          {title}
          {withHint && <div className={cn.balaneFrsHint}>i</div>}
        </div>
        <div />
        <div />
      </div>
      {children}
      <div className={cn.balanceFrsItemTotal}>
        <div className={cn.balanceFrsItemTotalValue}>Total: </div>
        <div className={cn.balanceFrsItemTotalValue}>
          {left && total !== undefined
            ? formatBalance(total, baseCurrency)
            : ''}
        </div>
        <div className={cn.balanceFrsItemTotalValue}>
          {right && total !== undefined
            ? formatBalance(total, baseCurrency)
            : ''}
        </div>
      </div>
    </div>
  );
};

export default BalanceFrsItem;
